module.exports = __webpack_public_path__ + "static/img/home_11_1.4bd3b50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homePage_new/home_11_1.png
// module id = PoFL
// module chunks = 3 64